module.exports = __webpack_public_path__ + "img/icon-footer-weiterbilden.5aa05989.svg";